<template>
  <div>
    <v-row>
      <v-col md="6" cols="12">
        <h2 v-if="!ModeFolio">Fecha: {{ date }}</h2>
        <div v-if="!ModeFolio" style="
            display: flex;
            align-items: center;
            gap: 4px;
            white-space: nowrap;
          ">
          <h3 style="margin: 0">
            Lista de precios{{ dataDocTimes.Eb ? " base" : "" }}:
          </h3>
          <span style="font: 16px sans-serif;">
            {{ dataDocTimes.Dsc ? dataDocTimes.Dsc : "Sin descripción" }}
          </span>
        </div>

        <v-menu v-if="ModeFolio" ref="menu" v-model="menu" :close-on-content-click="true" transition="scale-transition"
          offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="date" label="Fecha Seleccionada" prepend-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on"></v-text-field>
          </template>
          <!-- :allowedDates="allowedDates" -->
          <v-date-picker v-model="date" @change="onChangeDate()" no-title @input="menu = false" scrollable>
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="6" cols="12">
        <v-row>
          <v-col md="6" cols="12" style="display: flex">
            <v-btn v-if="!ModeFolio" @click="
              playersNumber > 1 ? playersNumber-- : '';
            changePlayersNumber();
            ">
              <v-icon color="red"> mdi-minus </v-icon>
            </v-btn>
            <v-text-field disabled class="" outlined dense @keyup="changePlayersNumber()" v-model="playersNumber"
              label="Indica el numero de jugadores">
            </v-text-field>
            <v-btn @click="
              playersNumber++;
            changePlayersNumber();
            ">
              <v-icon color="green"> mdi-plus </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" cols="12">
        Horarios:<br />
        <template v-for="(horario, index) in horarios">
          <v-chip :disabled="!horario.av && rvaDepto != '-Oex-6sLxf-fbXSFs4NF'" :key="index" :color="selectedHorario == index ? 'success' : 'primary'"
            @click="selectHorario(index, horario)" class="ma-2" label>
            {{ index }}
          </v-chip>
        </template>
      </v-col>
      <v-col md="6" cols="12">
        Salidas:<br />
        <template v-for="(bahia, index) in bahiasFromTimes">
          <v-chip v-if="index != 'av' " :key="index" :disabled="!bahia.av && rvaDepto != '-Oex-6sLxf-fbXSFs4NF'"
            :color="selectedBahia == index ? 'success' : 'pink'" @click="selectBahias(index, bahia.dcs)" dark
            class="ma-2" label>
            {{ bahia.bnm }}
          </v-chip>
        </template>
      </v-col>
      <v-col md="12" cols="12">
        Duraciones:<br />
        <template v-for="(duracion, index) in duracionesFromBahias">
          <v-chip :key="index" :color="selectedDuracion == index ? 'success' : 'purple'"
            @click="selectDuracion(index, duracion)" dark :disabled="!duracion.av && rvaDepto != '-Oex-6sLxf-fbXSFs4NF'" class="ma-2" label>
            {{ parseDurationName(Number(index)) }}
          </v-chip>
        </template>
        <v-divider></v-divider>
      </v-col>
      <v-col md="12" cols="12" v-show="selectedDuracion">
        <v-tabs next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline" show-arrows
          v-model="extraTabs">
          <v-tabs-slider></v-tabs-slider>
          <v-tab> Jugadores </v-tab>
          <v-tab> Notas </v-tab>
        </v-tabs>
        <v-tabs-items v-model="extraTabs">
          <v-tab-item class="pa-2">
            <v-form ref="playersForm">
              <v-simple-table>
                <thead>
                  <tr>
                    <th width="40%">Jugador</th>
                    <th width="30%">Categoria Precio</th>
                    <th width="20%">
                      Precio
                      <v-btn @click="editarPrecioToogle = !editarPrecioToogle" x-small color="primary">Editar</v-btn>
                    </th>
                    <th width="10%">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(player, index) in dataForm.Jugadores">
                    <tr :key="index" v-show="!autoReply || index === 0">
                      <td class="pa-2">
                        <v-combobox :label="'Jugador'" class="mb-n6" outlined :search-input.sync="player.Nombre" dense
                          v-model="player.dataClient" :items="comp_clients" item-value="Id" item-disabled="blqd"
                          @input="interceptorClient(player, index)">
                          <template v-slot:item="data">
                            <v-list-item-content v-bind:class="{ accesoDenegado: data.item.blqd }">
                              {{ data.item.text }}<br />
                              <b v-if="data.item.esMiembro"><v-icon small color="yellow">
                                  mdi-star
                                </v-icon>
                                Miembro</b>
                              <b v-if="data.item.blqd"><v-icon small color="red"> mdi-cancel </v-icon>
                                Acceso denegado</b>
                              <b v-if="data.item.blqd" class="mx-2 mb-2">{{
                                data.item.nots
                                }}</b>
                              <v-chip color="primary" v-if="data.item.tipo">
                                {{ data.item.tipo ? data.item.tipo : "" }}
                              </v-chip>
                            </v-list-item-content>
                          </template>
                          <v-btn small elevation="0" slot="append-outer" @click="
                            modals.cliente = true;
                          idx.cliente++;
                          indexItem = index;
                          " dark :color="$pgsHelper.uiConfig().mainColor">
                            <v-icon>mdi-account-plus</v-icon>
                          </v-btn>
                        </v-combobox>
                      </td>
                      <td class="pa-2">
                        <h4 v-if="player.et == 'C'" class="red--text">
                          Jugador Cancelado
                        </h4>
                        <h4 v-if="player.et == 'P'" class="green--text">
                          Pagado
                        </h4>
                        <v-autocomplete v-if="player.et == 'R'" class="mb-n6" :items="comp_precios" outlined dense
                          item-value="id" item-text="cnm" v-model="player.Categoria"
                          @input="selectCategoriaPrecio(index)" label="Seleccione una categoría de precio">
                          <template v-slot:item="data">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ data.item.cnm }}
                              </v-list-item-title>
                              <v-list-item-subtitle>Precio: ${{ data.item.pco.C }}
                                {{ data.item.pco.M }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </td>
                      <td class="pa-2">
                        <v-text-field class="mb-n6" v-if="player.Categoria && editarPrecioToogle" outlined dense
                          @keypress="
                            $pgsHelper.onlyNumber($event, player.Pco.C)
                            " v-model="player.Pco.C" label="Precio">
                          <v-chip slot="append-outer" color="green" dark small
                            v-if="player.Categoria && editarPrecioToogle">
                            {{ player.Pco.M }}
                          </v-chip>
                        </v-text-field>
                        <v-chip color="green" dark small v-if="player.Categoria && !editarPrecioToogle">
                          ${{ player.Pco.C }}
                          {{ player.Pco.M }}
                        </v-chip>
                        <v-chip color="red" dark small v-if="!player.Categoria">
                          Precio invalido
                        </v-chip>
                        <div v-if="checkInCheckIn(player.id + '-' + 'ACTRESERVA')">
                          <v-chip color="green" small dark v-if="
                            !checkInCheckIn(player.id + '-' + 'ACTRESERVA')
                              .isOwner
                          " style="">
                            <b v-bind="attrs" v-on="on">Proceso checkin :{{
                              checkInCheckIn(player.id + "-" + "ACTRESERVA")
                                .cjr.nm
                            }}</b>
                          </v-chip>
                        </div>
                        <div v-if="checkInCheckIn(player.id + '-' + 'ACTRESERVA')">
                          <v-btn v-if="
                            checkInCheckIn(player.id + '-' + 'ACTRESERVA')
                              .isOwner
                          " @click="liberar(player.id, 'ACTRESERVA')" color="red" small dark>
                            Liberar
                          </v-btn>
                        </div>
                      </td>
                      <td>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="player.et != 'P'" color="primary" small dark v-bind="attrs" v-on="on">
                              Opciones
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-if="dataForm.Jugadores.length > 1" @click="replicarJugador(player)">
                              <v-list-item-title>Replicar Jugador</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="dataForm.Jugadores.length > 1" @click="replicarTarifa(player)">
                              <v-list-item-title>Replicar Categoria de precio</v-list-item-title>
                            </v-list-item>

                            <v-list-item v-if="index != 0 && !player.id" @click="deletePlayer(index)">
                              <v-list-item-title> Eliminar</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="cancelPlayer(index)" v-if="player.id">
                              <v-list-item-title class="red--text">
                                Cancelar reserva de jugador</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </v-simple-table>
            </v-form>
          </v-tab-item>
          <v-tab-item class="pa-2">
            <v-textarea label="Notas de la reserva" v-model="dataForm.nota"></v-textarea>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="height: calc(100vh - 160px)">
        <div style="position: fixed !important; bottom: 0 !important" class="bottomPanel">
          <v-card style="height: 150px" elevation="0">
            <v-card-text>
              <v-alert style="" icon="mdi-currency-usd" type="info" text>
                <h5>
                  Total en {{ currency.getCurrencyDefault() }}:${{
                    $pgsHelper.formatNumber(
                      totales[currency.getCurrencyDefault()]
                    )
                  }}
                  || Total en USD:${{ $pgsHelper.formatNumber(totales.USD) }}
                </h5>
              </v-alert>
              <v-row>
                <v-col md="6"><v-btn v-if="ModeFolio" :loading="loading" @click="cancelAllPlayer()"
                    style="width: inherit" x-large block color="error">
                    Cancelar Todos
                  </v-btn></v-col>
                <v-col md="6"><v-btn :loading="loading" style="width: inherit" @click="bookInteceptor()" x-large block
                    color="success">
                    {{ ModeFolio ? "Guardar Cambios" : "Reservar" }}
                  </v-btn></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <modal v-model="modals.cliente" :showFooter="false" title="Agregar Cliente">
      <FormClientes :edit="false" :key="idx.cliente" :indexItem="indexItem" @onCreate="vincular" :dataEdit="{}"
        @toggle="toggle"></FormClientes>
    </modal>
    <v-dialog v-model="interceptBooking" max-width="500">
      <v-card >
        <v-card-title>Bahia ocupada</v-card-title>
        <v-card-text>
          El horario que seleccionaste ya tiene una reserva. <br/>Tu reserva se agregará a la bahía de forma compartida.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="interceptBooking = false"  text color="error" >Cancelar</v-btn>
          <v-btn @click="book(); interceptBooking=false" text color="success">Reservar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Cliente from "../../../clases/Cliente.js";
import FormClientes from "../../Clientes/Clientes/ClienteForm.vue";
import ActivityReservation from "../../../clases/ActivityReservation.js";
import Currencies from "../../../clases/Currencies.js";
import RW from "../../../clases/RealtimeWriter.js";
export default {
  name: "BookingActivityFormV2",
  components: { FormClientes },
  props: {
    bahias: Array,
    actividades: Array,
    rvaDepto: String,
    availability: Array,
    ModeFolio: Boolean,
    selectedFolio: String,
    selectedDate: String,
  },
  data() {
    return {
      interceptBooking:false,
      firstLoad: false,
      actualListener: "",
      inProcessCheckIn: {},
      loading: false,
      currency: Currencies,
      indexItem: 0,
      extraTabs: 0,
      menu: false,
      dayNumber: null,
      date: moment().format("YYYY-MM-DD"),
      ACT_Timesheet: {},
      selectedHorario: null,
      selectedBahia: null,
      selectedDuracion: null,
      editarPrecioToogle: false,
      bahiasFromTimes: {},
      duracionesFromBahias: {},
      CategoriasDisponibles: {},
      playersNumber: 1,
      updateHorarios: 0,
      idx: {
        cliente: 0,
      },
      modals: {
        cliente: false,
      },
      dataForm: {
        Jugadores: [new ActivityReservation()],
        nota: "",
      },
      reservas: [
        {
          Cliente: "Luis Lopez",
          HoraInicial: "07:00",
          HoraFinal: "08:00",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos Monte",
          HoraInicial: "07:00",
          HoraFinal: "08:00",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos Juan",
          HoraInicial: "07:00",
          HoraFinal: "08:30",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Pedron",
          HoraInicial: "07:30",
          HoraFinal: "09:00",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos Juan",
          HoraInicial: "8:50",
          HoraFinal: "10:00",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos Juan",
          HoraInicial: "20:00",
          HoraFinal: "23:00",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos v",
          HoraInicial: "19:00",
          HoraFinal: "20:30",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos Juan",
          HoraInicial: "20:00",
          HoraFinal: "23:00",
          color: "rgb(72, 149, 245)",
        },
        {
          Cliente: "Carlos Juan",
          HoraInicial: "23:00",
          HoraFinal: "23:30",
          color: "rgb(72, 149, 245)",
        },
      ],

      dataDocTimes: [],
    };
  },
  methods: {
    setReloadTimes() {
      this.updateHorarios++
      this.$toast.warning(
        "Cambios detectados en la disponibilidad"
      );
      /*if(this.selectedHorario){
        if(this.horarios[this.selectHorario]){
          this.selectHorario(this.selectedHorario,this.horarios[this.selectHorario])
        }
      }*/
    },
    toggle() {
      this.modals.cliente = false;
    },
    parseDurationName(minutes) {
      let hours = Math.floor(minutes / 60);
      let minutos = minutes % 60;
      let text = "";
      if (hours > 0) {
        text = text + "" + hours + "hrs. ";
      }
      if (minutos > 0) {
        text = text + " " + minutos + " min.";
      }
      return text;
    },
    cancelPlayer(index) {
      if (this.autoReply) {
        this.cancelAllPlayer();
      }
      this.dataForm.Jugadores[index].setStatus("C");
    },
    cancelAllPlayer() {
      this.dataForm.Jugadores.forEach((ply) => {
        if (ply.et != "P") {
          ply.setStatus("C");
        }
      });
    },
    deletePlayer(index) {
      this.dataForm.Jugadores.splice(index, 1);
      this.playersNumber = this.dataForm.Jugadores.length;
    },
    liberar(idReserva, cuenta) {
      RW.delete(
        "RVA/CheckIns/" +
        moment().format("YYYY-MM-DD") +
        "/" +
        idReserva +
        "/" +
        cuenta
      );
    },
    vincular(data) {
      let cliente = new Cliente(data.data);
      cliente.text = cliente.getNombreCompleto();
      this.dataForm.Jugadores[data.indexItem].dataClient = cliente;
      this.setPlayerData(
        this.dataForm.Jugadores[data.indexItem],
        data.indexItem
      );
      //this.players[data.indexItem].IdCliente = data.id
    },
    interceptorClient(player, index) {
      /*let tenant = this.$store.getters.getFirebaseApp.tenant;

      if (tenant === "PCUN") {
        //this.setPlayerData(player, index)
        if (player?.dataClient?.Id) {
          this.clienteEvaliv = this.$pgsHelper.cloneObj(player);
          this.indexPlayerEvaliv = index;
          this.evalivIndex++;
          this.showModalEvaliv = true;
        } else {
          this.setPlayerData(player, index);
        }
      } else {*/
      this.setPlayerData(player, index);
      /*}*/
    },
    async setPlayerData(player, index = null) {
      if (player.dataClient?.Id) {
        player.isClient = true;
        player.Id = player.dataClient.Id;
        player.name =
          player.dataClient.Apellidos + " " + player.dataClient.Nombres;
      } else {
        player.IdCliente = null;
        player.isClient = false;
        player.name = player.dataClient;
      }
      if (this.autoReply) {
        this.replicarJugador(player);
      }
    },
    selectCategoriaPrecio(index) {
      let categoriaPrecios = this.$pgsHelper.getById(
        this.comp_precios,
        "id",
        this.dataForm.Jugadores[index].Categoria
      );
      if (categoriaPrecios) {
        this.dataForm.Jugadores[index].Pco = {
          C: categoriaPrecios.pco.C,
          M: categoriaPrecios.pco.M,
        };
      }
      if (this.autoReply) {
        this.dataForm.Jugadores.forEach((ply) => {
          ply.Categoria = this.dataForm.Jugadores[index].Categoria;
          ply.Pco = {
            C: categoriaPrecios.pco.C,
            M: categoriaPrecios.pco.M,
          };
        });
      }
    },
    selectHorario(time, bahias) {
      this.selectedHorario = time;
      this.bahiasFromTimes = bahias;
      if (this.selectedBahia) {
        if (bahias[this.selectedBahia]) {
          if (bahias[this.selectedBahia]?.av) {
            this.selectBahias(
              this.selectedBahia,
              bahias[this.selectedBahia]?.dcs
            );
          } else {
            this.selectedBahia = null;
            this.selectedDuracion = null;
            this.duracionesFromBahias = {};
            this.CategoriasDisponibles = {};
          }
        } else {
          this.selectedBahia = null;
          this.selectedDuracion = null;
          this.duracionesFromBahias = {};
          this.CategoriasDisponibles = {};
        }
      }
    },
    selectBahias(bahia, duraciones = {}) {
      this.selectedBahia = bahia;
      this.duracionesFromBahias = duraciones;
      if (this.selectedDuracion) {
        if (duraciones[this.selectedDuracion]) {
          this.selectDuracion(
            this.selectedDuracion,
            duraciones[this.selectedDuracion]
          );
        } else {
          this.selectedDuracion = null;
          this.CategoriasDisponibles = {};
        }
      }
    },
    selectDuracion(duracion, precios, firstTime = false) {
      this.selectedDuracion = duracion;
      let disponibles = {};
      for (const pr in precios) {
        if (pr != "av") {
          disponibles[pr] = precios[pr];
        }
      }
      this.CategoriasDisponibles = disponibles;
      if (!this.firstLoad) {
        this.onChangeListPrecios();
      }
    },
    onChangeListPrecios() {
      this.dataForm.Jugadores.forEach((ply, index) => {
        if (ply.et != "P") {
          this.selectCategoriaPrecio(index);
        }
      });
    },
    async getInfoDocTimes() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let data = await firestore.queryBuilder("ACT_Timesheets/", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Iact", "==", this.rvaDepto),
        firestore.where("Dlat", "==", null),
        firestore.where("Rf.fi", "<=", this.date),
        firestore.where("Rf.ff", ">=", this.date),
        firestore.orderBy("Tenant", "asc"),
        firestore.orderBy("Iact", "asc"),
        firestore.orderBy("Rf.fi", "asc"),
        firestore.orderBy("Rf.ff", "asc"),
      ]);

      if (data.empty == true) {
        data = await firestore.queryBuilder("ACT_Timesheets/", [
          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
          firestore.where("Iact", "==", this.rvaDepto),
          firestore.where("Eb", "==", true),
        ]);
      }
      // console.log("data", data);
      let document = data.docs.map((doc) => {
        // console.log("doc", doc);
        return { id: doc.ref.id, ...doc.data() };
      });
      // console.log("document", document);
      if (document[0]) {
        let dataDocTimes = document[0];
        dataDocTimes.Times = this.OrderData(dataDocTimes);
        this.dataDocTimes = dataDocTimes;
        //dataDocTimes.Times = this.OrderData(dataDocTimes);
        this.ACT_Timesheet = dataDocTimes.Times;
      } else {
        this.ACT_Timesheet = {
          0: {},
          1: {},
          2: {},
          3: {},
          4: {},
          5: {},
          6: {},
        };
      }

      /*const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("RVA_TimeSheet/", id);
      const data = await firestore.getDoc(doc);
      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = { id: data.ref.id, ...data.data() };
      this.rvaDepto = document.RVAD
      this.getBahias();
      this.getPaquetesPrecio()
      document.Times = this.OrderData(document)
      this.dataDocTimes = document
      this.parseDocToForm(this.$pgsHelper.cloneObj(document))*/
    },
    async onChangeDate() {
      this.$emit("changeChildDate", this.date);
      this.dayNumber = moment(this.date).day();
    },
    OrderData(doc) {
      if (doc.Times) {
        let times = {};
        let diasArray = Object.entries(doc.Times);
        diasArray.forEach((day) => {
          let OrderHorarios = this.orderHorarios(day[1]);
          //dias.push({ day: day[0], Horarios: OrderHorarios });
          times[day[0]] = OrderHorarios;
        });
        return times;
      }
    },
    orderHorarios(horarios) {
      let horariosArray = Object.entries(horarios);

      let orderTime = this.$_.orderBy(horariosArray, "0", "asc");
      let orderenTimes = {};
      orderTime.forEach((time) => {
        orderenTimes[time[0]] = this.orderBahias(
          this.$pgsHelper.cloneObj(time[1])
        );
      });
      return orderenTimes;
    },
    orderBahias(bahias) {
      let bahiasArray = this.$pgsHelper.ArrayObjectToArray(bahias);
      bahiasArray.forEach((bahia) => {
        let existBahia = this.$pgsHelper.getById(this.bahias, "id", bahia.id);
        bahia.od = existBahia.od;
      });
      let orderBahia = this.$_.orderBy(bahiasArray, "od", "asc");
      let orderenBahias = {};
      orderBahia.forEach((bahia) => {
        let orderedDuraciones = this.orderDuraciones(
          this.$pgsHelper.cloneObj(bahia.dcs)
        );
        bahia.dcs = orderedDuraciones;
        orderenBahias[bahia.id] = bahia;
      });
      return orderenBahias;
    },
    orderDuraciones(duraciones) {
      let duracionesArray = Object.entries(duraciones);
      duracionesArray = this.$_.orderBy(duracionesArray, "0", "asc");
      let orderenDuracion = {};
      duracionesArray.forEach((duracion) => {
        orderenDuracion[duracion[0]] = duracion[1];
      });
      return orderenDuracion;
    },
    processAvailables(horarios) {
      if (horarios) {
        let times = this.$pgsHelper.cloneObj(horarios);
        for (const time in times) {
          let bahiasOcuped = 0;
          for (const bahia in times[time]) {
            let duracionesOcuped = 0;
            for (const duracion in times[time][bahia].dcs) {
              let init = new moment(this.date + "_" + time, "YYYY-MM-DD_HH:mm");
              let end = new moment(this.date + "_" + time, "YYYY-MM-DD_HH:mm");
              end.add(Number(duracion), "minutes");
              let duracionAvailable = true;
              //buscar dentro de las reservas actuales, si existe una en la bahia que choque con las fechas de inicio y termino de la duracion
              this.availability.forEach((res) => {
                if (res.et != "C") {
                  if (this.ModeFolio) {
                    if (res.fr == this.selectedFolio) {
                      return false;
                    }
                  }
                  if (res.bahia == bahia) {
                    let reserva_inicio = new moment(
                      this.date + "_" + res.HoraInicial,
                      "YYYY-MM-DD_HH:mm"
                    );

                    let reserva_fin = new moment(res.ft, "YYYY-MM-DD_HH:mm");
                    let noDisp = this.doDateRangesOverlap(
                      init.format("YYYY-MM-DDTHH:mm:ss"),
                      end.format("YYYY-MM-DDTHH:mm:ss"),
                      reserva_inicio.format("YYYY-MM-DDTHH:mm:ss"),
                      reserva_fin.format("YYYY-MM-DDTHH:mm:ss")
                    );
                    if (noDisp) {
                      duracionAvailable = !noDisp;
                    }
                    /*if (
                      reserva_inicio.add(1, "minutes") >= init &&
                      reserva_inicio.add(1, "minutes") <= end
                    ) {
                      duracionAvailable = false;
                    }
                    if (
                      reserva_fin.subtract(1, "minutes") >= init &&
                      reserva_fin.subtract(1, "minutes") <= end
                    ) {
                      duracionAvailable = false;
                    }*/
                  }
                }
              });
              times[time][bahia].dcs[duracion].av = duracionAvailable;
              if (!duracionAvailable) {
                duracionesOcuped++;
              }
            }
            let totalDuraciones = Object.keys(times[time][bahia].dcs).length;
            if (totalDuraciones == duracionesOcuped) {
              times[time][bahia].av = false;
              bahiasOcuped++;
            } else {
              times[time][bahia].av = true;
            }
          }
          let totalBahias = Object.keys(times[time]).length;
          if (bahiasOcuped == totalBahias) {
            times[time].av = false;
          } else {
            times[time].av = true;
          }
        }

        return times;
      } else {
        console.log("no recibi horarios");
      }
    },
    doDateRangesOverlap(start1, end1, start2, end2) {
      // Convertir las fechas y horas a objetos moment
      let startDateTime1 = moment(start1);
      let endDateTime1 = moment(end1);
      let startDateTime2 = moment(start2);
      let endDateTime2 = moment(end2);
      return (
        startDateTime1.isBefore(endDateTime2) &&
        startDateTime2.isBefore(endDateTime1)
      );
    },
    changePlayersNumber() {
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.dataForm.Jugadores.length < this.playersNumber) {
        var i;
        for (i = this.dataForm.Jugadores.length; i < this.playersNumber; i++) {
          this.dataForm.Jugadores.push(new ActivityReservation());
        }
      } else if (this.dataForm.Jugadores.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.dataForm.Jugadores.length; i) {
          this.dataForm.Jugadores.pop();
        }
      }
    },
    async replicarJugador(player) {
      this.dataForm.Jugadores.forEach(async (element, index) => {
        if (index != 0) {
          element.isClient = player.isClient;
          element.dataClient = player.dataClient;
          element.Nombre = player.Nombre;
        }
      });
    },
    async replicarTarifa(player) {
      this.dataForm.Jugadores.forEach(async (element, index) => {
        if (index != 0) {
          element.Categoria = player.Categoria;
          this.selectCategoriaPrecio(index);
        }
      });
    },
    async getReservasByFolio(folio) {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const data = await firestore.queryBuilder("ACT_Reservas", [
        firestore.where("fl", "==", folio),
        firestore.where(
          "tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let reservations = data.docs
        .map((doc) => {
          return { id: doc.ref.id, ...doc.data() };
        })
        .filter((doc) => {
          return doc.et != "C";
        });
      this.parseToForm(reservations);
    },
    parseToForm(reservas) {
      let jugadores = [];
      reservas.forEach((res) => {
        let player = new ActivityReservation(res);
        player.toDataForm();
        if (player.isClient) {
          let dataCliente = this.$pgsHelper.getById(
            this.comp_clients,
            "Id",
            player.cl.id
          );
          player.dataClient = dataCliente;
        }
        jugadores.push(player);
      });
      this.dataForm.Jugadores = jugadores;
      this.playersNumber = jugadores.length;
      this.dataForm.Jugadores.forEach((ply) => {
        this.setPlayerData(ply);
      });

      if (jugadores[0]) {
        this.firstLoad = true;
        this.date = jugadores[0].getFechaInicial();
        this.dayNumber = moment(this.date).day();
        this.selectedHorario = jugadores[0].getHoraInicial();
        let horario = ((this.horarios) ? this.horarios[this.selectedHorario] : false);
        if (horario) {
          this.selectHorario(this.selectedHorario, horario);
          this.selectedBahia = jugadores[0].bh.id;
          this.selectBahias(this.selectedBahia, horario[this.selectedBahia]?.dcs);
          this.selectedDuracion = jugadores[0].dc;
          this.selectDuracion(
            this.selectedDuracion,
            horario[this.selectedBahia]?.dcs[this.selectedDuracion],
            true
          );
        }
        this.dataForm.nota = jugadores[0].nt;
        this.firstLoad = false;
      }
    },
    async bookInteceptor() {
      if (this.selectedHorario) {
        if (this.horarios[this.selectedHorario]) {
          if (this.selectedBahia) {
            if (this.horarios[this.selectedHorario][this.selectedBahia].av == false) {
              this.interceptBooking = true
            } else {
              this.book()
            }
          }
        }
      }
      //this.book()
    },
    async book() {
      let data = [];
      this.dataForm.Jugadores.forEach((ply) => {
        let init = new moment(
          this.date + "_" + this.selectedHorario,
          "YYYY-MM-DD_HH:mm"
        );
        let end = new moment(
          this.date + "_" + this.selectedHorario,
          "YYYY-MM-DD_HH:mm"
        );
        end.add(Number(this.selectedDuracion), "minutes");
        let actividad = this.$pgsHelper.getById(
          this.actividades,
          "id",
          this.rvaDepto
        );
        let categoria = this.$pgsHelper.getById(
          this.comp_precios,
          "id",
          ply.Categoria
        );
        let bahia = this.$pgsHelper.getById(
          this.bahias,
          "id",
          this.selectedBahia
        );
        ply.toDataDoc({
          nt: this.dataForm.nota,
          fi: init.format("YYYY-MM-DD_HH:mm"),
          ft: end.format("YYYY-MM-DD_HH:mm"),
          bh: { id: this.selectedBahia, nm: bahia.nm },
          dc: Number(this.selectedDuracion),
          ac: { id: this.rvaDepto, nm: actividad.nm },
          dsc:
            actividad.nm +
            " " +
            bahia.nm +
            " " +
            ply.Nombre +
            " - " +
            init.format("YYYY-MM-DD HH:mm") +
            " a " +
            end.format("HH:mm"),
          ExtraParams: {},
          CategoriaData: categoria,
          ActividadData: actividad,
        });
        data.push(ply);
      });
      this.loading = true;

      let url = "ACT-Reservas-writeReservaGrupal";
      await this.$store.getters.getFirebaseApp.fba
        .call(url, {
          Reservas: data,
          Pax: data.length,
          Tenant: this.$store.getters.getFirebaseApp.tenant,
        })
        .then(async (result) => {
          if (result.data.ok) {
            this.loading = false;
            if (this.ModeFolio) {
              await this.getReservasByFolio(this.selectedFolio);
            } else {
              this.$emit("onSuccess");
            }
          } else {
            this.loading = false;
            this.$swal(
              "Error guardando la reserva",
              result.data.error,
              "error"
            );
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$swal(`Request failed: ${error}`);
        });
    },
    async getInCheckIn() {
      let date = moment().format("YYYY-MM-DD");
      if (this.actualListener != "") {
        this.killListenerInCheckIn(this.actualListener);
      }

      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/CheckIns/" + date,
        null,
        (snapshot) => {
          try {
            if (snapshot.exists()) {
              let process = {};
              let arrayReservas = snapshot.val();
              let reservas = Object.entries(arrayReservas);
              reservas.forEach((element) => {
                let idReserva = element[0];
                let cuentas = Object.entries(element[1]);

                cuentas.forEach((acc) => {
                  process[idReserva + "-" + acc[0]] = acc[1];
                  let claims = this.$route.params.user.tokenResult.claims;
                  let config = this.$pgsHelper.readConfig();
                  claims.user_id;
                  config.caja_id;
                  if (
                    acc[1].cja.id == config.caja_id &&
                    acc[1].cjr.id == claims.user_id
                  ) {
                    process[idReserva + "-" + acc[0]].isOwner = true;
                  } else {
                    process[idReserva + "-" + acc[0]].isOwner = false;
                  }
                });
              });

              this.inProcessCheckIn = process;
            } else {
              this.inProcessCheckIn = {};
            }
          } catch (e) {
            console.log(e);
          }
        }
      );

      this.actualListener = "RVA/CheckIns/" + date;
    },
    killListenerInCheckIn(date) {
      const ref = this.$store.getters.getFirebaseApp.database.ref(date);
      this.$store.getters.getFirebaseApp.database.off(ref);
    },
    unSelectBahia() {
      this.selectedBahia = null
      if (this.ModeFolio) {
        this.getReservasByFolio(this.selectedFolio);
      }
    },
    checkInCheckIn(val) {
      if (this.inProcessCheckIn[val]) {
        return this.inProcessCheckIn[val];
      } else {
        return null;
      }
    },
  },
  watch: {
    horarios: function (newQuestion, oldQuestion) {
      /*if (this.selectedHorario) {
        if (this.horarios[this.selectedHorario]) {
          if (this.selectedBahia) {
            if (this.horarios[this.selectedHorario][this.selectedBahia].av == false) {
              //this.selectedBahia = null
              this.selectHorario(this.selectedHorario, this.horarios[this.selectedHorario])
              if (this.ModeFolio) {
                this.getReservasByFolio(this.selectedFolio);
              }
            }
          }
        }
      }*/
    }
  },
  destroyed: function () {
    if (this.actualListener != "") {
      this.killListenerInCheckIn(this.actualListener);
    }
  },
  computed: {
    autoReply() {
      if (this.$store.getters.getFirebaseApp.tenant == "BOKA") {
        return true;
      } else {
        return false;
      }
    },
    totales() {
      let totalPesos = 0;
      let totalDollar = 0;
      this.dataForm.Jugadores.forEach((ply) => {
        if (ply.Pco.M == "USD") {
          totalDollar += Number(ply.Pco.C);
          totalPesos += Currencies.getExchangeRateByCurrency(
            ply.Pco.C,
            ply.Pco.M,
            Currencies.getCurrencyDefault()
          );
        } else {
          totalPesos += Number(ply.Pco.C);
          totalDollar += Currencies.getExchangeRateByCurrency(
            ply.Pco.C,
            Currencies.getCurrencyDefault(),
            "USD"
          );
        }
      });
      let data = {};
      data[Currencies.getCurrencyDefault()] = Number(totalPesos);
      data["USD"] = Number(totalDollar);
      return data;
    },
    horarios() {
      try {
        this.$pgsHelper.forceReactivity(this.updateHorarios);
        let horarios = {};
        if (this.ACT_Timesheet) {
          let available = this.processAvailables(
            this.ACT_Timesheet[String(this.dayNumber)]
          );
          horarios = available; //this.ACT_Timesheet[String(this.dayNumber)];
          /*if (this.selectedHorario) {
            if (horarios[this.selectedHorario]) {
              this.selectHorario(this.selectedHorario, horarios[this.selectedHorario])
              if (this.selectedBahia) {
                if (horarios[this.selectedHorario][this.selectedBahia].av == false) {
                  this.unSelectBahia()

                }
              }
            }
          }*/
        }
        return horarios;
      } catch (e) {
        console.log(e);
        return {};
      }
    },
    comp_precios() {
      let data = [];
      let categoriasPrecios = Object.entries(this.CategoriasDisponibles);
      categoriasPrecios.forEach((cate) => {
        data.push({ id: cate[0], ...cate[1] });
      });
      return data;
    },
    comp_clients() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((cli) => {
        if (cli.ExtraData?.Membresia?.Membresia) {
          cli.esMiembro = true;
        } else {
          cli.esMiembro = false;
        }
        cli.text = cli.getNombreCompleto();
        clientes.push(cli);
      });
      return this.$_.orderBy(clientes, "text", "asc");
      //return clientes;
    },
  },
  async mounted() {
    this.date = this.selectedDate;
    await this.getInfoDocTimes();
    this.dayNumber = moment(this.date).day();
    if (this.ModeFolio) {
      // console.log(this.selectedFolio);
      await this.getReservasByFolio(this.selectedFolio);
    }
    //await this.getInCheckIn();
  },
};
</script>
<style>
.bottomPanel {
  width: 100%;
}

.accesoDenegado {
  background: #ff00005c;
}
</style>
